if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        // Manual products are already rendered by Liquid.
        // Do not fetch Shopify's automatic recommendations and overwrite them.
        if (this.dataset.manual === 'true') {
          if (this.querySelector('.product-card')) {
            this.dispatchEvent(new CustomEvent('recommendations:loaded'));
          } else {
            this.dispatchEvent(new CustomEvent('recommendations:empty'));
          }

          return;
        }

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');

            if (recommendations === null) {
              this.closest('.shopify-section')?.remove();
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
              return;
            }

            if (recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (this.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (this.classList.contains('complementary-products')) {
                this.closest('.product__block')?.remove();
              } else {
                this.closest('.shopify-section')?.remove();
              }

              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  );
}